import { getCurrentFCCDate } from '../../components/Web/AddressSearch/constant';
import ACTIONTYPE_ADDRESS from './Constants';

const initialState = {
  usertypedAddress: '',
  userSelectedAddress: null,
  showErrorBanner: false,
  errorText: null,
  setPlanFilter: null,
  selectedDate: getCurrentFCCDate() || '',
  enableContinueButton: false,
  parsedAddress: {
    zip: null,
    muni: null,
    dispstr: null,
    state: null,
    entireStreetAddress: null,
    addressLine2: null,
  },
  fccLabelList: [],
  fccError: {
    value: false,
    errorText: null,
  },
  fccProspectPlansList: [],
  fccProspectError: {
    value: false,
    errorText: null,
  },
  retrieveZipCodeSuccess: null,
  retrieveZipCodeError: {
    value: false,
    errorText: null,
  },
  taxDetails: null,
  taxDetailsError: {
    value: false,
    errorText: null,
  },
  updatedJsonWithTax: null,
};

const addressSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONTYPE_ADDRESS.GET_FCC_DETAILS_ERROR:
      return {
        ...state,
        fccError: {
          errorText: action?.response,
          value: action?.value,
        },
      };
    case ACTIONTYPE_ADDRESS.GET_FCC_PROSPECT_PLANS_ERROR:
      return {
        ...state,
        fccProspectError: {
          errorText: action?.response,
          value: action?.value,
        },
      };
    case ACTIONTYPE_ADDRESS.NEW_BROWSING_API_CALL_SUCCESS:
      return { ...state, taxDetails: action?.value };
    case ACTIONTYPE_ADDRESS.UPDATE_TAX_DETAILS:
      return { ...state, updatedJsonWithTax: action?.data };
    case ACTIONTYPE_ADDRESS.NEW_BROWSING_API_CALL_ERROR:
      return {
        ...state,
        taxDetailsError: {
          errorText: action?.response,
          value: action?.value,
        },
      };
    case ACTIONTYPE_ADDRESS.GET_FCC_DETAILS_SUCCESS:
      return { ...state, fccLabelList: action?.value };

    case ACTIONTYPE_ADDRESS.GET_FCC_PROSPECT_PLANS_SUCCESS:
      return { ...state, fccProspectPlansList: action?.value };

    case ACTIONTYPE_ADDRESS.MAKE_RETRIEVE_ZIPCODE_CALL_ERROR:
      return {
        ...state,
        retrieveZipCodeError: {
          errorText: action?.response,
          value: action?.value,
        },
      };
    case ACTIONTYPE_ADDRESS.MAKE_RETRIEVE_ZIPCODE_CALL_SUCCESS:
      return { ...state, retrieveZipCodeSuccess: action?.value };
    case ACTIONTYPE_ADDRESS.RESET_ERROR_MESSAGE:
      return { ...state, showErrorBanner: false, errorText: null };
    case ACTIONTYPE_ADDRESS.SHOW_ERROR_MESSAGE:
      return {
        ...state,
        showErrorBanner: action?.data?.value,
        errorText: action?.data?.errorText?.length > 0 ? action?.data?.errorText?.[0]?.notifyMessage : action?.data?.errorText,
      };
    case ACTIONTYPE_ADDRESS.UPDATE_PARSED_ADDRESS:
      return {
        ...state,
        parsedAddress: {
          zip: action?.data?.zip || '',
          muni: action?.data?.muni || '',
          dispstr: action?.data?.dispstr || '',
          state: action?.data?.state || '',
          entireStreetAddress: action?.data?.disprawstr || '',
          addressLine2: action?.data?.parserAddressLine2 || '',
        },
      };
    case ACTIONTYPE_ADDRESS.UPDATE_USER_TYPED_ADDRESS:
      return { ...state, usertypedAddress: action?.data || '' };
    case ACTIONTYPE_ADDRESS.STORE_USER_SELECTED_ADDRESS:
      return { ...state, userSelectedAddress: action?.data || '' };
    case ACTIONTYPE_ADDRESS.UPDATE_CONTINUE_BUTTON_STATUS:
      return { ...state, enableContinueButton: action?.data || false };
    case ACTIONTYPE_ADDRESS.RESTORE_DEFAULT_ADDRESS_STATE:
      return initialState;
    case 'SET_PLAN_FILTER':
      return { ...state, setPlanFilter: action?.data };
    case 'SET_SELECTED_DATE':
      return { ...state, selectedDate: action?.data}
    default:
      return state;
  }
};

export default addressSearchReducer;
